import EditPage from "../../components/EditPage";
import PageHeaderEdit from "../../components/PageHeaderEdit";
import PageInfoListEdit from "../../components/PageInfoListEdit";
import PageInfoListItemEdit from "../../components/PageInfoListItemEdit";
import { UploadFolderIdProvider } from "../../util/UploadFolderIdContext";

export default function LedelseAnsatte() {
    const uploadFolderId = '1G1tm9SC4Suim42E46xZaEmYRcMStGt-X'
    return (
        <UploadFolderIdProvider folderId={uploadFolderId}>
            <EditPage apiPath="page/LedelseAnsatte">
                <PageHeaderEdit sectionKey="PageHeader" />
                <PageInfoListEdit sectionKey="Sec1"/>
                <PageInfoListEdit sectionKey="Sec2"/>
                <PageInfoListEdit sectionKey="Sec3" >
                    <PageInfoListItemEdit sectionKey="item1" setImage={true}/>
                </PageInfoListEdit>
                <PageInfoListEdit sectionKey="Sec4">
                    <PageInfoListItemEdit sectionKey="item1" setImage={true}/>
                    <PageInfoListItemEdit sectionKey="item2" setImage={true}/>
                    <PageInfoListItemEdit sectionKey="item3" setImage={true}/>
                </PageInfoListEdit>
            </EditPage>
        </UploadFolderIdProvider>
    );
}